<div class="nano-banana" [class.nano-banana--embedded]="embedded">
  <header class="nano-banana__header" *ngIf="showHeader">
    <div class="nano-top-composer">
      <div class="nano-top-title">
        <i class="fa-solid fa-brain" aria-hidden="true"></i>
        <span>Photo Lab</span>
      </div>
      <input
        #headerImageInput
        id="ieHeaderImageUpload"
        type="file"
        accept="image/png,image/jpeg,image/jpg,image/webp"
        (change)="onFileChange($event)"
        style="display: none"
      />
      <div class="textarea-wrapper">
        <textarea
          id="iePromptInputTop"
          class="user-input-textarea"
          [(ngModel)]="prompt"
          rows="1"
          placeholder="Text What would you like to change? Upload Image."
          [disabled]="processing.isProcessing"
        ></textarea>

        <button
          type="button"
          class="ie-upload-btn"
          (click)="headerImageInput.click()"
          [disabled]="processing.isProcessing"
          aria-label="Upload image"
        >
          <i class="fa-solid fa-image"></i>
        </button>

        <button
          type="button"
          class="btn-send-fixed"
          (click)="handleEdit()"
          [disabled]="!canSubmit"
          aria-label="Send edit request"
        >
          <i class="fas fa-arrow-up send-arrow-icon" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </header>

  <div class="nano-banana__content">
    <div class="nano-banana__editor">
      <div class="nano-card">
        <div class="nano-card__header">
          <div class="nano-card__title">
            <i class="fa-solid fa-pencil"></i>
            Upload photo, then ask...
          </div>
          <button
            class="nano-card__discard"
            type="button"
            *ngIf="previewUrl"
            (click)="clearSession()"
          >
            Discard
          </button>
        </div>

        <div class="nano-card__body">
          <label class="nano-dropzone" *ngIf="!previewUrl">
            <div class="nano-dropzone__icon">
              <i class="fa-solid fa-cloud-arrow-up"></i>
            </div>
            <p class="nano-dropzone__title"><span>Click to upload</span> or drag and drop</p>
            <p class="nano-dropzone__subtitle">PNG, JPG or WebP (MAX. 10MB)</p>
            <input type="file" accept="image/*" (change)="onFileChange($event)" />
          </label>

          <div class="nano-editor" *ngIf="previewUrl">
            <div class="nano-editor__grid">
              <div class="nano-panel">
                <span class="nano-panel__label">Original</span>
                <div class="nano-panel__frame">
                  <img [src]="previewUrl" alt="Original" />
                </div>
              </div>
              <div class="nano-panel">
                <span class="nano-panel__label">Result</span>
                <div class="nano-panel__frame nano-panel__frame--result">
                  <ng-container *ngIf="currentResult; else resultState">
                    <img [src]="currentResult" alt="Result" />
                    <a
                      class="nano-download"
                      [href]="currentResult"
                      download="edited-image.png"
                      aria-label="Download edited image"
                    >
                      <i class="fa-solid fa-download"></i>
                    </a>
                  </ng-container>
                  <ng-template #resultState>
                    <div class="nano-status" *ngIf="processing.isProcessing; else idleState">
                      <span class="nano-spinner"></span>
                      <p>Custom clarity in progress...</p>
                    </div>
                    <ng-template #idleState>
                      <p class="nano-idle">Describe changes below to generate</p>
                    </ng-template>
                  </ng-template>
                </div>
              </div>
            </div>

            <p class="nano-error" *ngIf="processing.error">{{ processing.error }}</p>
          </div>
        </div>
      </div>

    </div>

    <div class="nano-banana__history">
      <div class="nano-card nano-card--history">
        <div class="nano-card__header">
          <div class="nano-card__title">
            <i class="fa-solid fa-clock-rotate-left" *ngIf="history.length > 0"></i>
            History
          </div>
          <span class="nano-count">{{ history.length }}</span>
        </div>
        <div class="nano-card__body nano-history">
          <div class="nano-empty" *ngIf="history.length === 0">
            <div class="nano-empty__icon">
              <i class="fa-solid fa-clock"></i>
            </div>
            <p>No edits yet. Start creating!</p>
          </div>

          <div class="nano-history__list" *ngIf="history.length > 0">
            <div class="nano-history__item" *ngFor="let item of history">
              <img [src]="item.editedUrl" alt="Edited" />
              <div class="nano-history__meta">
                <p>"{{ item.prompt }}"</p>
                <span>{{ item.timestamp | date: 'shortTime' }}</span>
              </div>
              <div class="nano-history__actions">
                <button type="button" (click)="viewHistoryItem(item.editedUrl)" title="View result">
                  <i class="fa-regular fa-image"></i>
                </button>
                <button type="button" (click)="deleteHistoryItem(item.id)" title="Delete">
                  <i class="fa-solid fa-trash"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <footer class="nano-mobile" *ngIf="showMobileFooter">
    <ng-container *ngIf="!previewUrl; else mobileGenerate">
      <label class="nano-mobile__button">
        <i class="fa-solid fa-cloud-arrow-up"></i>
        Choose Image
        <input type="file" accept="image/*" (change)="onFileChange($event)" />
      </label>
    </ng-container>
    <ng-template #mobileGenerate>
      <button
        type="button"
        class="nano-mobile__button"
        (click)="handleEdit()"
        [disabled]="processing.isProcessing || !prompt.trim()"
      >
        <i class="fa-solid fa-wand-magic-sparkles"></i>
        Apply Nano Banana Edit
      </button>
    </ng-template>
  </footer>
</div>
